import React, { memo } from 'react'
import { Box } from 'mds-web-ui'

import Event from './Event'

const EventsList = memo(({ events, date }) => {
  if (events.length === 0) return null

  return (
    <Box role="list">
      {events.map((event, index) => (
        <Event
          // make key unique per calendar
          key={`${event.calendarData.id}_${event.id}`}
          event={event}
          date={date}
        />
      ))}
    </Box>
  )
})

export default EventsList
